import { render, staticRenderFns } from "./HolidayBalanceChart.vue?vue&type=template&id=28596cbe&scoped=true&lang=pug&"
import script from "./HolidayBalanceChart.vue?vue&type=script&lang=ts&"
export * from "./HolidayBalanceChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28596cbe",
  null
  
)

export default component.exports